<template>
  <v-layout row align-center justify-space-around>
    <v-flex xs12 order-lg2 id="hashtagsListings">
      <v-flex xs12>
        <v-btn outline fab dark small class="elevation-1" color="accent lighten-2" @click="goToPage('first')" :disabled="page === 1" style="position: absolute; left: 5px;">
          <v-icon>first_page</v-icon>
        </v-btn>
        <v-btn outline fab dark small class="elevation-1" color="accent lighten-2" @click="goToPage('previous')" :disabled="page === 1">
          <v-icon>keyboard_arrow_left</v-icon>
        </v-btn>
        <v-btn class="elevation-1 noHover" style="cursor: auto" outline fab dark small color="accent lighten-2">
          <span style="color: #727272">{{ page }}</span>
        </v-btn>
        <v-btn class="elevation-1" outline fab dark small color="accent lighten-2" @click="goToPage('next')" :disabled="lastPage">
          <v-icon>keyboard_arrow_right</v-icon>
        </v-btn>
      </v-flex>
      <v-flex style="min-height: 100px" class="pa-0" v-if="dataState === 'loading' || dataState === 'ready'" :class="dataState !== 'ready' ? 'blurClass' : ''">
        <v-list two-line class="pt-0">
          <v-divider v-if="dataState === 'ready'"></v-divider>
          <v-list-group v-for="(item, index) in hashtags" v-model="item._active" :key="index" append-icon="" no-action>
            <v-list-tile
              slot="activator"
              :key="item._tag"
              style="max-width: 100%"
              @click.stop="goToTag(item._tag)"
              class='pa-0 afterHeader'
              :style='index % 2 === 0 ? "background-color: #EFEFEF99" : "background-color: #FFFFFF99"'
            >
              <v-list-tile-content class='hashtags' style="width: 15%">
                <v-list-tile-title v-html="'#' + item._tag" @click="" class="pointer"></v-list-tile-title>
              </v-list-tile-content>
              <v-divider vertical></v-divider>
              <v-list-tile-content class='counters' :style="options.sortBy === '_tweet_count' ? 'background-color: #64b5f611' : ''">
                <v-list-tile-title class="text-md-center" style="display:flex; justify-content: center"><v-icon small left class="mr-2" color="blue lighten-3">fab fa-twitter</v-icon><p>{{ formatNumber(item._tweet_count) }}</p></v-list-tile-title>
              </v-list-tile-content>
              <v-divider vertical></v-divider>
              <v-list-tile-content class='counters' :style="options.sortBy === '_retweet_count' ? 'background-color: #00FF0011' : ''">
                <v-list-tile-title class="text-md-center" style="display:flex; justify-content: center"><v-icon small left class="mr-2" color="green lighten-2">fas fa-retweet</v-icon><p>{{ formatNumber(item._retweet_count) }}</p></v-list-tile-title>
              </v-list-tile-content>
              <v-divider vertical></v-divider>
              <v-list-tile-content class='counters' :style="options.sortBy === '_favorite_count' ? 'background-color: #FF000011' : ''">
                <v-list-tile-title class="text-md-center" style="display:flex; justify-content: center"><v-icon small left class="mr-2" color="red lighten-2">fas fa-heart</v-icon><p>{{ formatNumber(item._favorite_count) }}</p></v-list-tile-title>
              </v-list-tile-content>
              <v-divider vertical></v-divider>
              <v-list-tile-content class='counters' :style="options.sortBy === '_reply_count' ? 'background-color: #0000FF11' : ''">
                <v-list-tile-title class="text-md-center" style="display:flex; justify-content: center"><v-icon small left class="mr-2" color="blue lighten-2">fas fa-comment</v-icon><p>{{ formatNumber(item._reply_count) }}</p></v-list-tile-title>
              </v-list-tile-content>
              <v-divider vertical></v-divider>
              <v-list-tile-content class='counters' :style="options.sortBy === '_quote_count' ? 'background-color: #00FFFF11' : ''">
                <v-list-tile-title class="text-md-center" style="display:flex; justify-content: center"><v-icon small left class="mr-2" color="teal lighten-2">fas fa-quote-right</v-icon><p>{{ formatNumber(item._quote_count) }}</p></v-list-tile-title>
              </v-list-tile-content>
              <v-divider vertical></v-divider>
              <v-list-tile-content class='counters align-center' :style="options.sortBy === '_created_at' ? 'background-color: #FFB74D11' : ''">
                <v-layout row class="align-center justify-content-center px-1">
                  <v-flex sm2>
                    <v-icon small class="mr-2" color="orange lighten-2">fas fa-calendar</v-icon>
                  </v-flex>
                  <v-flex>
                    <v-list-tile-title>{{ formatDate(getLocalDate(item._created_at)) }}</v-list-tile-title>
                    <v-list-tile-sub-title v-html="formatTime(getLocalDate(item._created_at))"></v-list-tile-sub-title>
                  </v-flex>
                </v-layout>
              </v-list-tile-content>
              <v-divider vertical></v-divider>
              <v-list-tile-content class='counters' style="display: flex; align-items: center; justify-content: center" @click.stop="getTweets(index, false)">
                <v-list-tile-content><v-btn class="ma-0 px-2" color="blue white--text">View Tweets</v-btn></v-list-tile-content>
              </v-list-tile-content>
               <v-divider vertical></v-divider>
              <v-list-tile-avatar @click.stop="backtrack(item._id, 'hashtag', item._created_at)" color="secondary" size="40" class="pointer">
                <v-btn icon>
                  <v-icon>fas fa-backward</v-icon>
                </v-btn>
              </v-list-tile-avatar>
            </v-list-tile>
            <!-- <template> -->
            <v-list-tile two-line avatar v-for="(item, index1) in tweets" :key="index1" class="hashtagListingTweetList">
              <v-list-tile-content
                :key="item._id"
                avatar
                style="width: 100%; max-height: 70px"
                class='px-1'
                :style='innerListStyle(index, index1)'>
                <v-layout row style="width: 100%">
                  <v-list-tile-content class='pr-4 tweets verticalAlign' style="width: 35%;display: flex;flex-direction: row;justify-content: left;align-items: center">
                    <v-list-tile-avatar @click="goToUser(item._user_screen_name)" class="pointer avatar">
                      <img :src="item._user_profile_image_url_https">
                    </v-list-tile-avatar>
                    <v-flex>
                      <v-list-tile-title @click="goToUser(item._user_screen_name)" class="pointer">{{item._user_name}}<span class="caption pl-1">{{'@'+item._user_screen_name}}</span></v-list-tile-title>
                      <v-list-tile-sub-title class="pointer tweetText" @click="goToTweet(item._twitter_id, item._user_screen_name)">{{ item._text.length > 140 ? item._text.slice(0,140) + '...' : item._text }}</v-list-tile-sub-title>
                    </v-flex>
                  </v-list-tile-content>
                  <v-list-tile-content class='tweetCounters'>
                    <v-list-tile-title class="text-md-center" style="display:flex; justify-content: center"><v-icon small left class="mr-2" color="gray lighten-2">fas fa-users</v-icon><p>{{ formatNumber(item._user_followers_count) }}</p></v-list-tile-title>
                  </v-list-tile-content>
                  <v-list-tile-content class='tweetCounters'>
                    <v-list-tile-title class="text-md-center" style="display:flex; justify-content: center"><v-icon small left class="mr-2" color="green lighten-2">fas fa-retweet</v-icon><p>{{ formatNumber(item._retweet_count) }}</p></v-list-tile-title>
                  </v-list-tile-content>
                  <v-list-tile-content class='tweetCounters'>
                    <v-list-tile-title class="text-md-center" style="display:flex; justify-content: center"><v-icon small left class="mr-2" color="red lighten-2">fas fa-heart</v-icon><p>{{ formatNumber(item._favorite_count) }}</p></v-list-tile-title>
                  </v-list-tile-content>
                  <v-list-tile-content class='tweetCounters'>
                    <v-list-tile-title class="text-md-center" style="display:flex; justify-content: center"><v-icon small left class="mr-2" color="blue lighten-2">fas fa-comment</v-icon><p>{{ formatNumber(item._reply_count) }}</p></v-list-tile-title>
                  </v-list-tile-content>
                  <v-list-tile-content class='tweetCounters'>
                    <v-list-tile-title class="text-md-center" style="display:flex; justify-content: center"><v-icon small left class="mr-2" color="teal lighten-2">fas fa-quote-right</v-icon><p>{{ formatNumber(item._quote_count) }}</p></v-list-tile-title>
                  </v-list-tile-content>
                  <v-divider v-if="options.sortBy === '_user_followers_count'" vertical></v-divider>
                  <v-list-tile-content v-if="options.sortBy === '_user_followers_count'" class='tweetCounters'>
                    <v-list-tile-title class="text-md-center" style="display:flex; justify-content: center"><v-icon small left class="mr-2" color="purple lighten-2">fas fa-bullhorn</v-icon><p>{{ formatNumber(item._user_followers_count) }}</p></v-list-tile-title>
                  </v-list-tile-content>
                  <v-list-tile-content class='tweetCounters align-center' style="width: 15%">
                    <v-layout row class="align-center justify-content-center">
                      <v-flex sm2>
                        <v-icon small class="mr-2" color="orange lighten-2">fas fa-calendar</v-icon>
                      </v-flex>
                      <v-flex>
                        <v-list-tile-title>{{ formatDate(getLocalDate(item._created_at)) }}</v-list-tile-title>
                        <v-list-tile-sub-title v-html="formatTime(getLocalDate(item._created_at))"></v-list-tile-sub-title>
                      </v-flex>
                    </v-layout>
                  </v-list-tile-content>
                  <v-list-tile-avatar @click.stop="backtrackTweets(item._tweet_id, 'tweet', item._created_at)" color="secondary" size="40" class="pointer" style="margin:auto">
                    <v-btn icon>
                      <v-icon>fas fa-backward</v-icon>
                    </v-btn>
                  </v-list-tile-avatar>
                  <v-list-tile-avatar @click.stop="selectedTweet = item._tweet_id; deleteTweetConfirmationDialog = true" color="secondary" size="40" class="pointer" style="margin: auto;">
                    <v-btn icon>
                      <v-icon>fas fa-trash</v-icon>
                    </v-btn>
                  </v-list-tile-avatar>
                </v-layout>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile class="hashtagListingTweetList" v-if="tweets.length !== item._tweet_count && dataTweetsState === 'ready'"><v-list-tile-content style="width: 100%" class="align-center"><v-btn outline @click.stop="getMoreTweets(index, item._tweet_count)" class="ma-0 px-2" color="blue white--text">View More</v-btn></v-list-tile-content></v-list-tile>
            <v-list-tile v-if="dataTweetsState === 'loading'">
              <v-list-tile-content style="width: 100%" class="align-center">
                <v-progress-circular
                :size="70"
                :width="7"
                color="primary"
                indeterminate>
                </v-progress-circular>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile v-else-if="dataTweetsState === 'error'">
              <div style="display: flex; align-items: center; width: 100%; flex-direction: column"><v-icon style="font-size: 40px !important" class="error--text">warning</v-icon><p class="accent--text mb-0 ml-2 subheading font-weight-bold">error connecting to server</p></div>
            </v-list-tile>
          </v-list-group>
        </v-list>
      </v-flex>
      <template v-if="dataState === 'loading'">
        <center class="alternateState">
          <v-progress-circular
            :size="70"
            :width="7"
            color="primary"
            indeterminate
          ></v-progress-circular>
        </center>
      </template>
      <template v-else-if="dataState === 'noData'">
        <div class="d-flex" style="flex-direction: column; align-items: center"><v-icon class="primary--text" style="font-size: 40px !important;width:100%">warning</v-icon><p class="accent--text mb-0 ml-2 subheading font-weight-bold">no data found</p></div>
      </template>
      <template v-else-if="dataState === 'error'">
        <div class="d-flex" style="flex-direction: column; align-items: center"><v-icon class="error--text" style="font-size: 40px !important">warning</v-icon><p class="accent--text mb-0 ml-2 subheading font-weight-bold">error connecting to server</p></div>
      </template>
      <v-flex xs12>
        <v-btn outline fab dark small class="elevation-1" color="accent lighten-2" @click="goToPage('first')" :disabled="page === 1" style="position: absolute; left: 5px;">
          <v-icon>first_page</v-icon>
        </v-btn>
        <v-btn outline fab dark small class="elevation-1" color="accent lighten-2" @click="goToPage('previous')" :disabled="page === 1">
          <v-icon>keyboard_arrow_left</v-icon>
        </v-btn>
        <v-btn class="elevation-1 noHover" style="cursor: auto" outline fab dark small color="accent lighten-2">
          <span style="color: #727272">{{ page }}</span>
        </v-btn>
        <v-btn class="elevation-1" outline fab dark small color="accent lighten-2" @click="goToPage('next')" :disabled="lastPage">
          <v-icon>keyboard_arrow_right</v-icon>
        </v-btn>
      </v-flex>
    </v-flex>
    <v-dialog
      v-model="deleteTweetConfirmationDialog"
      width="300"
    >
      <v-card class="secondary">
        <v-card-title class="headline">Delete tweet?</v-card-title>
        <v-card-text>
          <v-btn @click="deleteTweet" :loading="deleteTweetLoading">Confirm</v-btn>
          <v-btn @click="deleteTweetConfirmationDialog = false; selectedTweet = null" :disabled="deleteTweetLoading">Cancel</v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-layout>
</template>
<style>
  #hashtagsListings .v-list__tile{
    padding-right: 0
  }
  #hashtagsListings .v-list__tile__content{
    padding-right: 0 !important
  }
  #hashtagsListings .v-list__group__items--no-action .v-list__tile{
    padding-left: 5px
  }
  #hashtagsListings .v-btn:focus:before{
    background-color: white !important;
  }
  #hashtagsListings .v-btn--disabled{
    background-color: #e0e0e0 !important;
    border: 1px solid #727272;
    -webkit-box-shadow: 0 2px 1px -1px rgba(0,0,0,.2),0 1px 1px 0 rgba(0,0,0,.14),0 1px 3px 0 rgba(0,0,0,.12)!important;
    box-shadow: 0 2px 1px -1px rgba(0,0,0,.2),0 1px 1px 0 rgba(0,0,0,.14),0 1px 3px 0 rgba(0,0,0,.12)!important;
  }
  #hashtagsListings .v-btn--disabled:focus:before{
    background-color: #e0e0e0 !important;
  }
  #hashtagsListings .v-btn--disabled i{
    color: #727272 !important;
  }
  #hashtagsListings div{
    flex: none;
  }
  #hashtagsListings .afterHeader{
    width: 100%
  }
</style>
<style scoped>
  .alternateState{
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
  .blurClass{
    filter: blur(5px);
    -webkit-filter: blur(5px);
  }
  .counters{
    flex: none;
    width: calc(12% - 10px)
  }
  .tweetText{ white-space: normal; max-height: 80px;}
  .avatar{ margin-top: auto; margin-bottom: auto }
  .pointer{ cursor: pointer; }
  .tweetCounters{ margin-top: auto; margin-bottom: auto; width: calc(10% - 27px); }
  /*.hashtags{ width: 300px; }*/
  .tweets{ width: 340px; margin-right: 10px !important;}
  .v-list__group.v-list__group--active:before, .v-list__group.v-list__group--active:after{
    left: 0;
  }
  .verticalAlign{ margin-top: auto; margin-bottom: auto }
  .v-list__group__header.v-list__group__header--active .afterHeader:after{
    content: "";
    height: 1px;
    position: absolute;
    -webkit-transition: .3s cubic-bezier(.25,.8,.5,1); 
    transition: .3s cubic-bezier(.25,.8,.5,1); 
    width: 100%;
    left: 0;
    background-color: #ededed;
  }
  .noHover:hover{background-color: white !important}
  .noHover:hover:before{background-color: transparent !important}
</style>
<script>
import axios from 'axios'
import underscore from 'underscore'
import { mapGetters, mapMutations } from 'vuex'
import { formatTime, formatDate, getLocalDate } from '@/helpers/formatters'
import numeral from 'numeral'

export default {
  props: {
    filters: {
      type: Object,
      default: () => ({})
    },
    options: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      dataState: 'loading',
      dataTweetsState: 'loading',
      hashtags: [],
      page: 1,
      lastPage: false,
      tweets: [],
      deleteTweetConfirmationDialog: false,
      selectedTweet: null,
      deleteTweetLoading: false
    }
  },
  computed: {
    ...mapGetters('auth', ['isLoggedIn']),
    ...mapGetters('filters', ['getQuery', 'getFilters'])
  },
  methods: {
    ...mapMutations('notification', ['notify']),
    formatDate: formatDate,
    formatTime: formatTime,
    getLocalDate: getLocalDate,
    backtrack: function (id, type, date) {
      let query = this.$route.query
      query.id = id
      query.type = type
      query.date = date
      query.connections = ['hashtag']
      query.objects = ['hashtag']
      this.$router.push({ path: '/backtracker', query: query })
    },
    backtrackTweets: function (id, type, date) {
      let query = this.$route.query
      query.id = id
      query.type = type
      query.date = date
      query.connections = ['reply', 'retweet', 'quote']
      query.objects = ['tweet']
      this.$router.push({ path: '/backtracker', query: query })
    },
    deleteTweet () {
      console.log(this.selectedTweet)
      this.deleteTweetLoading = true
      axios.all([
        this.$store.dispatch('deleteTweetById', {id: this.selectedTweet, query: '?projectUuid=' + this.getFilters.projectUuid})
      ]).then(axios.spread((response) => {
        if (response.data.status === 'SUCCESS') {
          this.selectedTweet = null
          this.deleteTweetConfirmationDialog = false
        } else {
          this.notify({message: 'Something went wrong while fetching data.', show: true})
        }
        this.getData()
        this.deleteTweetLoading = false
      })).catch((err) => {
        this.deleteTweetLoading = false
        this.notify({message: 'Something went wrong while connecting to the server.', show: true})
        console.log(err)
      })
    },
    innerListStyle: function (hashtagIndex, tweetIndex) {
      if (hashtagIndex % 2 === 0) {
        if (tweetIndex % 2 === 0) {
          return 'background-color: #FFFFFF99'
        } else {
          return 'background-color: #EFEFEF99'
        }
      } else {
        if (tweetIndex % 2 === 0) {
          return 'background-color: #EFEFEF99'
        } else {
          return 'background-color: #FFFFFF99'
        }
      }
    },
    getMoreTweets: function (index, totalTweets) {
      if (this.tweets.length !== totalTweets) {
        this.getTweets(index, true)
      }
    },
    formatNumber: function (value) {
      return Number(value) > 999 ? numeral(Number(value)).format('0.0a').toUpperCase() : value
    },
    goToTag (name) {
      window.open('https://twitter.com/hashtag/' + name, '_blank')
    },
    goToUser (name) {
      window.open('https://twitter.com/' + name, '_blank')
    },
    goToTweet (id, name) {
      window.open('https://twitter.com/' + name + '/status/' + id, '_blank')
    },
    goToPage (direction) {
      var newPage = this.page
      if (direction === 'first') {
        newPage = 1
      } else if (direction === 'previous') {
        newPage--
      } else if (direction === 'next') {
        newPage++
      }
      if (newPage !== this.page) {
        this.page = newPage
        this.getData()
      }
    },
    getTweets: function (index, increment) {
      var timeout = 0
      if (!increment) {
        this.hashtags.forEach(function (item, idx) { if (idx !== index) item._active = false })
        timeout = 500
      }
      var self = this
      setTimeout(function () {
        var tweetPageNumber = 1
        if (!increment) {
          self.tweets = []
          self.hashtags[index]._active = !self.hashtags[index]._active
        } else {
          tweetPageNumber = (self.tweets.length / 5) + 1
        }
        if (self.hashtags[index]._active) {
          self.dataTweetsState = 'loading'
          axios.all([
            self.$store.dispatch('getTweets', self.getQuery({sortBy: self.options.sortBy === '_tweet_count' ? '_user_followers_count' : self.options.sortBy, order: self.options.orderBy, hashtag: self.hashtags[index]._tag, pageSize: 5, pageNumber: tweetPageNumber}))
          ]).then(axios.spread((response) => {
            if (response.data.status === 'SUCCESS') {
              if (response.data.payload.length > 0) {
                if (increment) {
                  response.data.payload.forEach(function (item) {
                    self.tweets.push(item)
                  })
                } else {
                  self.tweets = response.data.payload
                }
                self.dataTweetsState = 'ready'
              } else {
                self.dataTweetsState = 'noData'
              }
            } else {
              self.dataTweetsState = 'error'
              self.notify({message: 'Something went wrong while fetching data.', show: true})
            }
          })).catch((err) => {
            self.dataTweetsState = 'error'
            self.notify({message: 'Something went wrong while connecting to the server.', show: true})
            console.log(err)
          })
        }
      }, timeout, index)
    },
    getData: function () {
      this.dataState = 'loading'
      axios.all([
        this.$store.dispatch('getHashtagsWithStats', this.getQuery({sortBy: this.options.sortBy, order: this.options.orderBy, pageSize: 30, pageNumber: this.page}))
      ]).then(axios.spread((response) => {
        if (response.data.status === 'SUCCESS') {
          response.data.payload.forEach(function (item) { item._active = false })
          if (response.data.payload.length > 0) {
            this.hashtags = response.data.payload
            this.dataState = 'ready'
            this.lastPage = (response.data.payload.length < 30)
          } else {
            this.dataState = 'noData'
            this.lastPage = true
          }
        } else {
          this.dataState = 'error'
          this.lastPage = true
          this.notify({message: 'Something went wrong while fetching data.', show: true})
        }
      })).catch((err) => {
        this.lastPage = true
        this.dataState = 'error'
        this.notify({message: 'Something went wrong while connecting to the server.', show: true})
        console.log(err)
      })
    }
  },
  watch: {
    filters: {
      deep: true,
      immediate: true,
      handler (newVal, oldVal) {
        if (oldVal && newVal && !underscore.isEqual(newVal, oldVal) && this.filters.dirty === false) {
          this.page = 1
          this.getData()
        }
      }
    },
    options: {
      deep: true,
      immediate: true,
      handler (newVal, oldVal) {
        if (oldVal && newVal && !underscore.isEqual(newVal, oldVal) && this.filters.dirty === false) {
          this.page = 1
          this.getData()
        }
      }
    }
  },
  mounted: function () {
    this.getData()
  }
}
</script>


// WEBPACK FOOTER //
// src/components/listings/HashtagsListing.vue